;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { Button } from 'reactstrap';
import { MdChevronRight } from 'react-icons/md';
import { getI18nUtils } from '../i18n/i18n-utils';
import { Dictionaries, Locale } from '../i18n/i18n-config';
import { getActiveFacetsFromSearchParams } from '../api/jobs';
import { useParams, useRouter, useSearchParams } from 'next/navigation';
import queryString from 'query-string';
import useWindowWidth from '../hooks/useWindowWidth';
import escapeHtml from '../utils/escapeHtml';

const FilterSummary = ({
  label = true,
  className,
  toggleSideNav,
  dictionary,
}: {
  label?: boolean;
  className?: string;
  toggleSideNav?: () => void;
  dictionary: Partial<Dictionaries>;
}) => {
  const { push } = useRouter();
  const { locale } = useParams<{ locale: Locale }>();
  const searchParams = useSearchParams();
  const windowWidth = useWindowWidth();
  const onMobile = windowWidth && windowWidth < 992;
  const activeFacets = getActiveFacetsFromSearchParams(searchParams, { exclude: ['radius', 'page', 'what', 'where', 'sort'] });

  const { formatMessage } = getI18nUtils(dictionary);

  const activeFilters = Object.values(activeFacets).flat();
  if (activeFilters.length === 0) return null;

  return (
    // display property set through parent component
    <div className={`filterSummary d-flex justify-content-between mb-3 mb-lg-0 py-3 ${className || ''}`}>
      <div className="d-flex">
        {label && (
          <label htmlFor="activeFilters" className="my-1 py-2">
            {formatMessage({ id: 'active-filters' })}
          </label>
        )}
        <ul id="activeFilters" className="mb-0 list-unstyled d-flex flex-wrap">
          {Object.entries(activeFacets).map(([facetGroup, facets]) =>
            facets.map((facet, i) => (
              <li key={`activeFilter-${facetGroup}_${i}`} className="activeFacet">
                <Button
                  className={`me-2 my-1 px-2 px-lg-3 text-start border-0 ${onMobile && 'border-bottom'} rounded-0`}
                  color="light"
                  onClick={() => {
                    push(
                      `/${locale}/jobs/?${queryString.stringify({ ...activeFacets, [facetGroup]: facets.filter((f) => f !== facet) })}`
                    );
                  }}
                >
                  {formatMessage({ id: escapeHtml(facet.replace('!', ' ')) })} <span className="ms-3 text-primary">&#10005;</span>
                </Button>
              </li>
            ))
          )}
        </ul>
      </div>
      {toggleSideNav && (
        <Button size="xs" color="white" onClick={toggleSideNav} className="p-1 text-dark d-lg-none">
          <MdChevronRight size="30" />
        </Button>
      )}
      <Button
        id="filter-reset"
        color="white"
        onClick={() => push(`/${locale}/jobs/`)}
        className="text-primary align-self-end align-self-lg-start my-1"
      >
        {formatMessage({ id: 'reset-filters' })}
      </Button>
    </div>
  );
};

export default FilterSummary;
